<template>
  <list-form @submit.prevent="doSearch" @reset.prevent="doReset" :can-back="true" @back="toIdBackIssuance"
    :disabled="disabled">
    <template #search-form>
      <div class="row">
        <vuex-text-search-item class="col" maxLength="60" label="資料名" bind="document_name" />
        <vuex-text-search-item class="col" maxLength="200" label="概要" bind="outline" />
      </div>
      <div class="row">
        <vuex-text-search-item class="col" maxLength="255" label="ファイル名" bind="file_name" />
        <div style="width: 50%;"></div>
      </div>
    </template>
    <template #table>
      <div v-if="publicDocuments.length">
        <plain-table :headers="tableHeaders" :data="tableData" :can-register="false" :pagination="paginationStatus"
          :sort="sortStatus" @select="toDetail" @change-page="doChangePage" @sort="doSort" />
      </div>
      <danger-alert v-else message="表示する資料がありませんでした。" />
    </template>
  </list-form>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import ListForm from '@/views/templates/forms/ListForm';
import VuexTextSearchItem from '@/views/molecules/searchItems/VuexTextSearchItem';
import PlainTable from '@/views/molecules/PlainTable';
import DangerAlert from '@/views/atoms/alerts/DangerAlert';
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent';

export default {
  name: 'PublicDocumentList',
  components: {
    ListForm,
    VuexTextSearchItem,
    PlainTable,
    DangerAlert
  },
  data() {
    return {
      tableHeaders: [
        { label: '資料名', column: 'document_name', setStyle: { width: '20%', nowrap: false } },
        { label: '概要', column: 'outline', setStyle: { width: '60%', nowrap: true } },
        { label: 'ファイル名', column: 'file_name', setStyle: { width: '20%', nowrap: false } },
      ],
      disabled: false,
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  mixins: [AddonLoadPageEvent],
  provide: {
    bindModule: 'public_document_index',
  },
  inject: ['$constant'],
  computed: {
    ...mapState('public_document_index', ['publicDocuments', 'paginationStatus', 'sortStatus', 'management_company_id']),
    ...mapState('account', {
      is_guest: state => state.is_guest,
      guest_issuance_request_id: state => state.guest.issuance_request_id,
    }),
    tableData() {
      return this.publicDocuments.map(publicDocuments => {
        return {
          id: publicDocuments.id,
          document_name: publicDocuments.document_name,
          outline: publicDocuments.outline,
          file_name: publicDocuments.file_name,
        }
      })
    },
  },
  methods: {
    ...mapMutations('public_document_index', ['setCurrentPage', 'setPerPage', 'setBackUrl', 'setSortColumn']),
    loadPage() {
      this.$route.params.management_company_id ? sessionStorage.setItem('management_company_id', this.$route.params.management_company_id) : '';
      this.$route.params.type ? sessionStorage.setItem('type', this.$route.params.type) : '';
      this.$route.params.id ? sessionStorage.setItem('id', this.$route.params.id) : '';
      if (this.paginationStatus.per_page === null) {
        this.setPerPage({ value: this.$constant.PAGINATION.PER_PAGE })
      }
      return this.$store
        .dispatch('public_document_index/load', { management_company_id: this.$route.params.management_company_id ? this.$route.params.management_company_id : sessionStorage.getItem('management_company_id'), prevRoute: this.prevRoute })
        .then(() => {
          this.$root.showFlashMessage()
        })
        .catch(reason => this.$root.failApi(reason))
    },
    doSearch() {
      this.setCurrentPage({ value: 1 })
      this.loadPage()
    },
    doReset() {
      this.$store.commit('public_document_index/resetForms')
      this.setCurrentPage({ value: 1 });
      this.loadPage();
    },
    doChangePage(page) {
      this.setCurrentPage({ value: page })
      return this.$store
        .dispatch('public_document_index/changePage', { management_company_id: this.$route.params.management_company_id ? this.$route.params.management_company_id : sessionStorage.getItem('management_company_id'), prevRoute: this.prevRoute })
        .then(() => {
          this.$root.showFlashMessage()
        })
        .catch(reason => this.$root.failApi(reason))
    },
    doSort(column) {
      this.setSortColumn({ column: column });
      this.loadPage();
    },
    toDetail(id) {
      this.$router.push({ name: this.is_guest ? 'GuestPublicDocumentViewer' : 'PublicDocumentViewer', params: { id: id } })
    },
    toIdBackIssuance() {
      if (this.is_guest) {
        return this.$router.push({name: 'GuestIssuanceRequestViewer', params: {'id': this.guest_issuance_request_id }});
      }
      const type = this.$route.params.type ? this.$route.params.type : sessionStorage.getItem('type');
      const id = this.$route.params.id ? this.$route.params.id : sessionStorage.getItem('id');
      if (type === 'Owner') {
        this.$router.push({ name: 'IssuanceRequestOwnViewer', params: { id: id } });
      }
      if (type === 'Viewer') {
        this.$router.push({ name: 'IssuanceRequestViewer', params: { id: id } });
      }
    }
  },
}
</script>
